import { render, staticRenderFns } from "./audiences-group-manage-add.vue?vue&type=template&id=58b0cba6&scoped=true&"
import script from "./audiences-group-manage-add.vue?vue&type=script&lang=js&"
export * from "./audiences-group-manage-add.vue?vue&type=script&lang=js&"
import style0 from "./audiences-group-manage-add.vue?vue&type=style&index=0&id=58b0cba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b0cba6",
  null
  
)

export default component.exports